import { render } from "./AVB.vue?vue&type=template&id=a5a6d396&ts=true"
import script from "./AVB.vue?vue&type=script&lang=ts"
export * from "./AVB.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__